export default __webpack_public_path__ + "static/media/uk.8a7abc5b.svg";